import { useState } from 'react';

import dynamic from 'next/dynamic';

import CustomIcon from '@components/utils/CustomIcon';
import { FavoriteDeleteIcon } from '@assets/icons';
import { PaletteColor } from '@utils/types';

import { ColCustomIcon } from './style';

const LoginModal = dynamic(
  () => import('./FavoriteModal').then((mod) => mod.LoginModal),
  {
    ssr: false,
  }
);

const MyFavoriteBeforeLogin = ({
  fontsize,
  fontColor,
}: {
  fontsize?: number;
  fontColor?: PaletteColor;
}) => {
  const [showLoginModal, setShowLoginModal] = useState(false);

  const toggleLoginModal = () => {
    setShowLoginModal(!showLoginModal);
  };

  return (
    <>
      <ColCustomIcon onClick={toggleLoginModal}>
        <CustomIcon
          fontSize={fontsize ?? 24}
          paletteColor={fontColor ?? 'coral'}
          icon={FavoriteDeleteIcon}
        />
      </ColCustomIcon>
      {showLoginModal ? <LoginModal toggleModal={toggleLoginModal} /> : null}
    </>
  );
};
export default MyFavoriteBeforeLogin;
